module.exports = __webpack_public_path__ + "img/Leo.a0d9e803.png";